module.exports = __webpack_public_path__ + "static/media/alert-message.bce6fe32.pdf";